// Vendor imports
const { createSelector } = require('reselect')
// Sibling imports
const allProviders = require('./providers')

const providers = createSelector(
  state => state.user.hasRollout('apple_auth'),
  hasAppleAuth => (
    hasAppleAuth
    ? allProviders
    : allProviders.filter(provider => provider.id !== 'apple')
  )
)

module.exports = {
  providers
}
